import fetchGrapQl from "./fetchGraphQl";
import { useQuery } from "react-query";

export const getUserData = (userId: string, email: string) => async () => {
  const { data } = await fetchGrapQl(
    `
      query queryUserValue {
        users(where: {email: {_eq: "${email}"}}) {
          edit_settings
          email
        }
      }
    `,
    "queryUserValue",
    userId
  );

  return data;
};

export const useUserFarms = (userId: string) => {
  const { data = [], status } = useQuery(
    "userFarms",
    async () => {
      const { data } = await fetchGrapQl(
        `
          query queryUserFarms {
            users_settings {
              farm_name
            }
          }
        `,
        "queryUserFarms",
        userId
      );

      return data?.users_settings;
    },
    { refetchOnWindowFocus: true }
  );

  return status === "loading" ? [] : data;
};

export const UseUserEditSettings = (userId: string, farm_name: string) => {
  return fetchGrapQl(
    `
      query queryUserEditSettings {
        users_settings(where: {farm_name: {_eq: "${farm_name}"}}) {
          edit_settings
        }
      }
    `,
    "queryUserEditSettings",
    userId
  );
};

export const fetchSettings = (userId: string, ean: string) => async () => {
  const { data } = await fetchGrapQl(
    `
      query querySettings {
        settings {
          farm_name
          ean
        }
      }
    `,
    "querySettings",
    userId,
    ean
  );

  return data.settings;
};

export const useSettings = (userId: string, ean: string) => {
  return useQuery("settings", fetchSettings(userId, ean), {
    refetchOnWindowFocus: true,
  });
};
